import React, {useState} from 'react';

import Modal from 'ui-library/modals/Modal';

interface JsonMapperConfigModalProps {
  initialConfigJson?: string;
  onRequestSubmit?: (configJson: string) => void;
  onRequestClose: () => void;
}

function JsonMapperConfigModal(props: JsonMapperConfigModalProps): JSX.Element {
  const [configJson, setConfigJson] = useState(props.initialConfigJson || '');

  return (
    <Modal
      buttons={[
        {
          submit: true,
          text: 'Save',
        },
      ]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        if (props.onRequestSubmit) {
          props.onRequestSubmit(configJson);
        }
      }}
      title="Configure JSON to CSV mapping"
    >
      <textarea
        rows={36}
        cols={100}
        placeholder="Configuration JSON"
        value={configJson}
        onChange={(e) => {
          setConfigJson(e.target.value);
        }}
      />
    </Modal>
  );
}

export default JsonMapperConfigModal;
